"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UriSlugRegistryEntrySchema = void 0;
exports.UriSlugRegistryEntrySchema = {
    "$id": "https://www.redbull.com/schemas/uri-slugs.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "UriSlugRegistryEntry",
    "description": "The uri slug registry entry associates resources with their assigned uri slug and allows for reverse lookups and availability checks.",
    "type": "object",
    "required": [
        "id",
        "type",
        "relationships"
    ],
    "properties": {
        "id": {
            "type": "string",
            "pattern": "^rrn:uri-slugs:[0-9a-z-_]+:[a-z]{2}-[A-Z]{2,3}:[a-zA-Z0-9-]+$"
        },
        "type": {
            "type": "string",
            "pattern": "^rrn:uri-slugs$"
        },
        "attributes": {
            "type": "object",
            "additionalProperties": true
        },
        "relationships": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
                "assignedResource": {
                    "type": "object",
                    "properties": {
                        "data": {
                            "allOf": [
                                {
                                    "type": "object",
                                    "$ref": "https://www.redbull.com/schemas/reference/localized/type-groups/content.schema.json"
                                },
                                {
                                    "type": "object",
                                    "properties": {
                                        "meta": {
                                            "type": "object",
                                            "additionalProperties": false,
                                            "properties": {
                                                "spaces": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            ]
                        }
                    },
                    "required": [
                        "data"
                    ]
                },
                "claimingResource": {
                    "type": "object",
                    "properties": {
                        "data": {
                            "allOf": [
                                {
                                    "type": "object",
                                    "$ref": "https://www.redbull.com/schemas/reference/localized/type-groups/content.schema.json"
                                },
                                {
                                    "type": "object",
                                    "properties": {
                                        "meta": {
                                            "type": "object",
                                            "additionalProperties": false,
                                            "properties": {
                                                "spaces": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            ]
                        }
                    },
                    "required": [
                        "data"
                    ]
                },
                "assignedResources": {
                    "type": "object",
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "allOf": [
                                    {
                                        "type": "object",
                                        "$ref": "https://www.redbull.com/schemas/reference/localized/type-groups/content.schema.json"
                                    },
                                    {
                                        "type": "object",
                                        "properties": {
                                            "meta": {
                                                "type": "object",
                                                "additionalProperties": false,
                                                "properties": {
                                                    "spaces": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "string"
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                ]
                            }
                        }
                    },
                    "required": [
                        "data"
                    ]
                },
                "claimingResources": {
                    "type": "object",
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "allOf": [
                                    {
                                        "type": "object",
                                        "$ref": "https://www.redbull.com/schemas/reference/localized/type-groups/content.schema.json"
                                    },
                                    {
                                        "type": "object",
                                        "properties": {
                                            "meta": {
                                                "type": "object",
                                                "additionalProperties": false,
                                                "properties": {
                                                    "spaces": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "string"
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                ]
                            }
                        }
                    },
                    "required": [
                        "data"
                    ]
                }
            },
            "required": [
                "assignedResource"
            ]
        }
    },
    "additionalProperties": false
};
//# sourceMappingURL=data:application/json;base64,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